import { ActiveLimitType } from './types';
import { SelectedWorker } from 'components/CreateOrderForm/types';

export type WorkerLimitErrorState = {
  activeLimitExceeded: boolean;
  activeLimitError: boolean;
  activeLimitType: ActiveLimitType;
  activeLimitRemaining: number;
};

const getContractRemaining = (
  contract: SelectedWorker['unified_contract'],
  contractLimit?: number | null,
): number | null => {
  const limit = contract?.limit ?? contractLimit;

  if (limit == null) {
    return null;
  }

  return limit - (contract?.total_orders_amount || 0);
};

const getWorkerMonthlyRemaining = (worker: SelectedWorker | null): number | null => {
  if (worker?.limit == null) {
    return null;
  }

  return worker.limit - (worker.monthly_payment || 0);
};

export const resolveWorkerLimitError = (
  amount: number,
  selectedWorker: SelectedWorker | null,
  contractLimit?: number | null,
): WorkerLimitErrorState | null => {
  if (!selectedWorker) {
    return null;
  }

  const contractRemaining = getContractRemaining(
    selectedWorker.unified_contract,
    contractLimit,
  );
  const workerRemaining = getWorkerMonthlyRemaining(selectedWorker);

  if (contractRemaining != null && contractRemaining < 0) {
    return {
      activeLimitExceeded: true,
      activeLimitError: false,
      activeLimitType: 'contract',
      activeLimitRemaining: contractRemaining,
    };
  }

  if (workerRemaining != null && workerRemaining < 0) {
    return {
      activeLimitExceeded: true,
      activeLimitError: false,
      activeLimitType: 'worker',
      activeLimitRemaining: workerRemaining,
    };
  }

  if (contractRemaining != null && contractRemaining >= 0 && amount > contractRemaining) {
    return {
      activeLimitExceeded: false,
      activeLimitError: true,
      activeLimitType: 'contract',
      activeLimitRemaining: contractRemaining,
    };
  }

  if (workerRemaining != null && workerRemaining >= 0 && amount > workerRemaining) {
    return {
      activeLimitExceeded: false,
      activeLimitError: true,
      activeLimitType: 'worker',
      activeLimitRemaining: workerRemaining,
    };
  }

  return null;
};
